module.exports = __webpack_public_path__ + "img/zip.3b922415.png";